import Content from '../../Content';
import { Inspector } from './editor/Inspector';

export const BUILDER_MENU_ID = 'component-builder';

const BuilderContent = () => (
	<Content id={BUILDER_MENU_ID}>
		<Inspector />
	</Content>
);

export default BuilderContent;
